import React from 'react'
import Link from 'gatsby-link'
import PropTypes from 'prop-types'
import { OutboundLink, trackCustomEvent } from 'gatsby-plugin-google-analytics'
import { colors } from '../utils/theme'

const CustomLink = ({
  href,
  to,
  analyticsId,
  onClick,
  children,
  ...otherProps
}) => {
  const localOnClick = (e) => {
    let label = href || to
    if (analyticsId) {
      label = analyticsId
    } else if (typeof children === 'string') {
      label = children
    }
    const eventProperties = {
      category: 'Link',
      action: 'Click',
      label,
      // value: number - optional - Numeric value associated with the event. (e.g. A product ID)
    }

    trackCustomEvent(eventProperties)

    if (onClick) {
      onClick(e)
    }
  }

  if (href) {
    return (
      <OutboundLink
        href={href}
        {...otherProps}
        onClick={localOnClick}
        css={{ color: colors.brightBlue }}
      >
        {children}
      </OutboundLink>
    )
  }
  return (
    <Link
      to={to}
      {...otherProps}
      css={{ color: colors.brightBlue }}
      onClick={localOnClick}
    >
      {children}
    </Link>
  )
}

CustomLink.propTypes = {
  analyticsId: PropTypes.string,
}

export default CustomLink
